import clsx from 'clsx';

import { RewardScene } from '@/types';

import { useReward } from '@/contexts/reward-context';
import { ArrowLeftIcon } from '@/components/svg-icons';

interface ShopTopBarProps {
	header?: string;
	rightContent?: React.ReactNode;
}

export const ShopTopBar = ({ header, rightContent }: ShopTopBarProps) => {
	const { 
		rewardScene, 
		setRewardScene, 
		isOpenedOutsideShop, 
		onClose 
	} = useReward();

	const onBack = () => {
		if (rewardScene === RewardScene.Shop) {
			setRewardScene(RewardScene.Home);
		} else if (rewardScene === RewardScene.VoucherRecord) {
			setRewardScene(RewardScene.MyVouchers);
		} else {
			if (isOpenedOutsideShop) {
				onClose();
			} else {
				setRewardScene(RewardScene.Shop);
			}
		}
	};

	return (
		<div 
			className={clsx('reward-top-bar', {
				'reward-top-bar--has-right': Boolean(rightContent)
			})}
		>
			<div 
				className="reward-top-bar__back"
				onClick={onBack}
			>
				<ArrowLeftIcon />
			</div>

			{header ? (
				<div className="reward-top-bar__title">{header}</div>
			) : null}
			
			{rightContent}
		</div>
	);
};